import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { ProColumns, ProTable, nanoid } from '@ant-design/pro-components';
import { Form, Modal, Select, Skeleton, message } from 'antd';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
// icons
import { DefaultOptionType } from 'antd/es/select';
import CustomInput from 'base/ui/components/CustomInput';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import CustomInputString from 'base/ui/components/Input/customInputString';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useTranslation } from 'react-i18next';
import { DetailZNSTemplate, ZNSTemplate, ZaloTask, ZaloTemplate, ZnsTableResponse } from 'services/ZNS/zns_services';
import { uiStore, znsPresenter, znsStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT, SYSTEM_TITLE, VARIABLE_CHECK_ZALO } from 'utils/constants';
import { DataSearchZNSTemplate } from '../model';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';

interface TableDetail {
  stt: number;
  // Tham số
  znsTemplateDetailName: string;
  type: string;
  maxLength: number;
  minLength: number;
  require: boolean;
  fieldName: string;
  discription: string;
}

// DANH SÁCH ZNS - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export function createListZNS() {
  return observer(() => {
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();
    document.title = t('page-title.list-zns') + ' - ' + SYSTEM_TITLE;

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const templateId = searchParams.get('templateId');

    const [open, setOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Loading all page
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [formDetail] = Form.useForm();

    // List data
    const [listDataSource, setListDataSource] = useState<ZNSTemplate[]>([]);
    // List dropdown zalo task
    const [dropdownZaloTask, setDropdownZaloTask] = useState<ZaloTask[]>([]);
    // List dropdown zalo template
    const [dropdownZaloTemplate, setDropdownZaloTemplate] = useState<CommonModel[]>([]);
    // Data detail zns template
    const [detailZNSTemplate, setDetailZNSTemplate] = useState<DetailZNSTemplate>();
    // Data search
    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
        orderBy: '',
        orderByDesc: '',
      },
    });

    const showDrawer = () => {
      setOpen(true);
    };
    const onClose = () => {
      setOpen(false);
    };
    const showModal = () => {
      setIsModalOpen(true);
    };
    const handleOk = () => {
      setIsModalOpen(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    // Columns list table
    const defaultColumn: ProColumns<ZNSTemplate>[] = [
      // stt
      {
        title: t('zalo-notification.stt'),
        dataIndex: 'stt',
        key: 'stt',
        width: 40,
        onCell: () => {
          return {
            style: {
              textAlign: 'center',
            },
          };
        },
      },
      // id mẫu báo cáo
      {
        title: t('zalo-notification.zns-id'),
        dataIndex: 'znsTemplateId',
        key: 'znsTemplateId',
        width: 70,
        ellipsis: true,
      },
      //  tên mẫu báo cáo
      {
        title: t('zalo-notification.zns-name'),
        dataIndex: 'znsTemplateName',
        key: 'znsTemplateName',
        width: 150,
        ellipsis: true,
      },
      // Nghiệp vụ sử dụng
      // {
      //   title: t('zalo-notification.use-major'),
      //   dataIndex: 'znsTask',
      //   key: 'znsTask',
      //   width: 100,
      //   ellipsis: true,
      // },
      // trạng thái
      {
        title: t('zalo-notification.status'),
        dataIndex: 'statusName',
        key: 'statusName',
        width: 70,
        ellipsis: true,
        render: (_, record) => {
          return (
            <div>
              {record.statusName === 'Đã duyệt' ? (
                <CheckCircleOutlined className="text-textSuccess custom__icon--antd" />
              ) : (
                <CloseCircleOutlined className="text-textError custom__icon--antd" />
              )}
              <span className={`${record.statusName === 'Đã duyệt' ? 'text-textSuccess' : 'text-textError'} ml-2`}>
                {record.statusName}
              </span>
            </div>
          );
        },
      },
      // chức năng
      {
        title: t('zalo-notification.function'),
        dataIndex: 'action',
        key: 'action',
        width: 200,
        onCell: () => {
          return {
            style: {
              textAlign: 'center',
            },
          };
        },
        render: (text, record) => {
          return (
            <div className="flex gap-2">
              <CustomButton
                onClick={() => {
                  setLoading(true);
                  // navigate(`?templateId=${record.znsTemplateId}`);
                  // if (templateId) {
                  // }
                  showModal();
                  getDetailZNSTemplate(record.znsTemplateId);
                }}
                size="small"
              >
                {t('btn.view')}
              </CustomButton>
              | <CustomButton
                size="small"
                onClick={() => {
                  window.open(record.previewUrl);
                }}
              >
                {t('btn.view-pre-zns')}
              </CustomButton>
              {/* <CustomButton size="small">{t('btn.download-report')}</CustomButton> */}
            </div>
          );
        },
      },
    ];
    const [columns, setColumn] = useState<ProColumns<ZNSTemplate>[]>(defaultColumn);

    // Function handle resize columns
    const handleResize =
      (index: number) =>
        (e: any, { size }: any) => {
          // Set columns
          setColumn((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
            };
            return nextColumns;
          });
        };

    // Cột trong table detail
    const columnsDetail: ProColumns<TableDetail>[] = [
      // tham số
      {
        title: 'Tham số',
        dataIndex: 'znsTemplateDetailName',
        key: 'znsTemplateDetailName',
        width: 100,
      },
      // Loại
      {
        title: 'Loại',
        dataIndex: 'type',
        key: 'type',
        width: 100,
      },
      // Số ký tự tối thiểu
      {
        title: 'Số ký tự tối thiểu',
        dataIndex: 'minLength',
        key: 'minLength',
        width: 100,
      },
      // Số ký tự tối đa
      {
        title: 'Số ký tự tối đa',
        dataIndex: 'maxLength',
        key: 'maxLength',
        width: 100,
      },
      // FieldName
      {
        title: 'FieldName',
        dataIndex: 'fieldName',
        key: 'fieldName',
        width: 100,
      },
      // Mô tả
      {
        title: 'Mô tả',
        dataIndex: 'discription',
        key: 'discription',
        width: 150,
        render: (text, record: TableDetail, index) => {
          return (
            <CustomSelect
              className="w-full"
              fieldNames={{ label: 'znsTaskName', value: 'znsTaskCode' }}
              filterOption={(input, option) => (option?.znsTaskName ?? '').toLowerCase().includes(input.toLowerCase())}
              options={dropdownZaloTask}
            />
          );
        },
        onCell: () => {
          return {};
        },
      },
    ];

    // Call api search
    const getDataSearchZNSTemplate = async (dataSearch: DataSearchZNSTemplate) => {
      await znsPresenter.listZNSTemplate(znsStore, { ...dataSearch, env: VARIABLE_CHECK_ZALO });
      if (znsStore.znsTemplateRespone.isSuccess) {
        setListDataSource(znsStore.znsTemplateRespone.data);
      }
    };
    // Call api dropdown zalo task
    // const getDropdownZaloTask = async () => {
    //   await znsPresenter.listDropdownZaloTask(znsStore);
    //   if (znsStore.dropdownZaloTaskRespone.isSuccess) {
    //     setDropdownZaloTask(znsStore.dropdownZaloTaskRespone.data);
    //   }
    // };

    // Call api dropdown mẫu ZNS zalo template
    // Call api dropdown mẫu ZNS
    const getDropdownZaloTemplate = async () => {
      await znsPresenter.listDropdownZNSTemplate(znsStore);
      if (znsStore.dropdownZnsTemplateRespone.isSuccess) {
        setDropdownZaloTemplate(znsStore.dropdownZnsTemplateRespone.data);
      }
    };


    // Call api detail zns template
    const getDetailZNSTemplate = async (templateId: string) => {
      await znsPresenter.detailZNSTemplate(znsStore, templateId);

      if (!znsStore.znsRespone.isSuccess) {
        setDetailZNSTemplate(znsStore.znsRespone.data);
        // Set value form detail
        formDetail.setFieldsValue(znsStore.znsRespone.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    useEffect(() => {
      setLoading(true);
      // getDropdownZaloTask();
      getDropdownZaloTemplate();
      setLoading(false);
    }, []);

    // Handle click button search
    const handleSearch = async (values: any) => {
      setLoading(true);

      const tempDataSearch = {
        ...values,
        paging: {
          ...dataSearch.paging,
          pageIndex: 1,
        },
      };

      await getDataSearchZNSTemplate(tempDataSearch);
      setLoading(false);
      onClose();
    };

    // Handle sync zns by button
    const handleSyncZNS = async () => {
      await znsPresenter.syncZNS(znsStore, {
        offset: 0,
        limit: 100,
      });
      if (znsStore.znsRespone.isSuccess) {
        message.success(znsStore.znsRespone.message);
      } else {
        message.error(znsStore.znsRespone.message);
      }
    };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: t('page-title.list-zns'),
          },
        ]}
        extras={
          <>
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Icon.Filter className="!fill-primary" />
            </CustomButton>
            <CustomButton onClick={handleSyncZNS} type="primary" icon={<SyncOutlined />}>
              {t('btn.zns-async')}
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer>
          <CustomProTable<ZNSTemplate>
            columns={columns}
            handleResize={handleResize}
            rowKey="stt"
            size="small"
            bordered
            search={false}
            loading={loading}
            request={async (params = {}, sort, filter) => {
              setLoading(true);
              const values = form.getFieldsValue();
              const tempDataSearch = {
                ...values,
              };
              const data: any = await getDataSearchZNSTemplate({
                ...tempDataSearch,
                paging: {
                  ...dataSearch.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                },
              });

              if (Object.values(sort).length) {
                setDataSearch({
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  },
                });
              }

              setLoading(false);

              return {
                data: data,
                success: znsStore.znsTemplateRespone.isSuccess,
              };
            }}
            dataSource={listDataSource}
            pagination={{
              pageSize: dataSearch.paging.pageSize,
              total: znsStore.znsTemplateRespone.paging?.recordsTotal,
              current: dataSearch.paging.pageIndex,
              responsive: true,
              position: ['topRight', 'bottomRight'],
              style: { margin: '10px 0' },
              showSizeChanger: false,
              showTotal: (total, range) => (
                <>
                  <span className="!absolute left-1">
                    {t('message.view')}{' '}
                    <CustomSelect
                      size="middle"
                      className="min-w-[72px] !rounded-none"
                      value={String(dataSearch.paging.pageSize)}
                      onChange={(value) => {
                        setDataSearch({
                          ...dataSearch,
                          paging: { ...dataSearch.paging, pageSize: Number(value) },
                        });
                      }}
                    >
                      {[10, 25, 50, 100].map((pageSize) => (
                        <Select.Option key={pageSize} value={String(pageSize)}>
                          {pageSize}
                        </Select.Option>
                      ))}
                    </CustomSelect>{' '}
                    {t('message.item')}
                  </span>
                  <span className="hidden md:block">{`${t('message.display')} ${range[0]}-${range[1]} ${t(
                    'message.of',
                  )} ${total} ${t('message.entries')}`}</span>
                </>
              ),
              onChange: (page, pageSize) => {
                setDataSearch({
                  ...dataSearch,
                  paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                });
              },
            }}
            columnsState={{
              persistenceKey: 'pro-table-callHistory',
              persistenceType: 'localStorage',
            }}
          />
        </BoxContainer>

        {/* Drawer search */}
        <SearchBox onClose={onClose} open={open}>
          <SearchForm form={form} onFinish={handleSearch} className="grid-cols-1">
            {/* mẫu zns */}
            <SearchItem label={t('search-form.zns-code')} name={'znsTemplateId'} className="col-span-1">
              <CustomSelect
                mode="multiple"
                // fieldNames={{ label: 'value', value: 'key' }}
                filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                options={dropdownZaloTemplate.map(item => {
                  return {
                    value: item.key,
                    label: item.value
                  }
                })}
              />
            </SearchItem>
            {/* nghiệp vụ */}
            {/* <SearchItem label={t('search-form.major')} name={'znsTaskCode'} className="col-span-1">
              <CustomSelect
                fieldNames={{ label: 'znsTaskName', value: 'znsTaskCode' }}
                filterOption={(input, option) =>
                  (option?.znsTaskName ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={dropdownZaloTask}
              />
            </SearchItem> */}
            <div className="col-span-1 sticky bottom-[-24px] py-2 bg-white w-full ">
              <CustomButton htmlType="submit" className="my-auto ml-auto" type="primary">
                {t('btn.search')}
              </CustomButton>
            </div>
          </SearchForm>
        </SearchBox>

        {/* XEM CHI TIẾT ZNS */}
        <Modal
          title={<div className="text-lg font-semibold">XEM CHI TIẾT ZNS</div>}
          open={isModalOpen}
          onOk={handleOk}
          width={1000}
          className={`${uiStore.theme.name} `}
          onCancel={handleCancel}
          footer={[]}
        >
          <Form form={formDetail} onFinish={console.log}>
            {/* id mẫu báo cáo */}
            <Form.Item labelCol={{ span: 6 }} name={'znsTemplateId'} label={t('zalo-notification.zns-id')}>
              <CustomInput readOnly className="border-none outline-none" />
            </Form.Item>
            {/* Tên mẫu zns */}
            <Form.Item labelCol={{ span: 6 }} name={'znsTemplateName'} label={t('zalo-notification.zns-name')}>
              <CustomInput readOnly className="border-none outline-none" />
            </Form.Item>
            {/* trạng thái */}
            <Form.Item labelCol={{ span: 6 }} name={'statusName'} label={t('zalo-notification.status')}>
              <CustomInput readOnly className="border-none outline-none" />
            </Form.Item>
            {/* Nghiệp vụ sử dụng */}
            <Form.Item
              className="outline-none"
              labelCol={{ span: 6 }}
              name={'znsTaskName'}
              label={t('zalo-notification.use-major')}
            >
              <CustomSelect fieldNames={{ label: 'znsTaskName', value: 'znsTaskCode' }} options={dropdownZaloTask} />
            </Form.Item>
            {/* Table detail zns */}
            <Skeleton active loading={loading}>
              <ProTable<TableDetail>
                className="!p-0 mb-4 [&_.ant-table-tbody>tr>td]:!py-0"
                size="small"
                rowKey={'stt'}
                bordered
                columns={columnsDetail}
                cardProps={{
                  className: '[&>div]:!p-0',
                }}
                dataSource={detailZNSTemplate?.znsTableResponses}
                pagination={false}
                options={false}
                dateFormatter="string"
                search={false}
              />
            </Skeleton>

            <div className="flex gap-4 justify-end">
              <Form.Item className="!mb-0 !mt-2">
                <CustomButton key="submit" type="default" onClick={handleOk}>
                  Hủy
                </CustomButton>
              </Form.Item>
              <Form.Item className="!mb-0 !mt-2">
                <CustomButton key="submit" type="primary" htmlType="submit" onClick={handleOk}>
                  Lưu
                </CustomButton>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      </PageWrapper>
    );
  });
}

export default createListZNS;
